import PaymentOrdersTable from "./PaymentOrdersTable";

export default PaymentOrdersTable;